<script>
import General from '@/services/General';

export default {
  name: 'modalPreviewGiveawayPopup',
  props: {
    popupsData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showModal: false,
      agreedToTerms: true,
      appButtonColor: '#0565BD',
      appButtonTextColor: '#ffffff',
      isLoadingParams: false,
    };
  },
  methods: {
    async loadAppParams() {
      this.isLoadingParams = true;
      try {
        const response = await General.getAppParams();
        if (response && response.data && response.data.app_params && Array.isArray(response.data.app_params)) {
          const params = response.data.app_params;
          const buttonColorParam = params.find(p => p.key === 'appButtonColor');
          const buttonTextColorParam = params.find(p => p.key === 'appButtonTextColor');
          
          if (buttonColorParam && buttonColorParam.value) {
            this.appButtonColor = buttonColorParam.value;
          }
          if (buttonTextColorParam && buttonTextColorParam.value) {
            this.appButtonTextColor = buttonTextColorParam.value;
          }
        }
      } catch (error) {
        console.error('Failed to load app params:', error);
      } finally {
        this.isLoadingParams = false;
      }
    },
    closeModal() {
      this.showModal = false;
      this.agreedToTerms = true;
    },
    getImageUrl() {
      return this.popupsData?.background_image || this.popupsData?.image || null;
    },
    getTitle() {
      return this.popupsData?.title || '';
    },
    getTopText() {
      return this.popupsData?.top_text || '';
    },
    getBottomText() {
      return this.popupsData?.bottom_text || '';
    },
    getActionText() {
      if (!this.popupsData?.action_text) {
        return 'REGISTREER NU!';
      }
      // Map constants to display text
      if (this.popupsData.action_text === 'MARKETING_POPUP_ACTION_WEBSITE') {
        return 'Visit Website';
      }
      if (this.popupsData.action_text === 'MARKETING_POPUP_ACTION_DEEPLINK') {
        return 'Open';
      }
      // Return the action_text as is for any other value
      return this.popupsData.action_text;
    },
    getAgreementText() {
      return this.popupsData?.participation_agreement_text || 'Ik ga akkoord met de algemene voorwaarden';
    },
    getTncUrl() {
      return this.popupsData?.participation_tnc_url || null;
    },
  },
};
</script>

<template>
  <b-modal
    id="preview_giveaway_popup"
    size="lg"
    v-model="showModal"
    @shown="loadAppParams"
    @hidden="closeModal"
    hide-header
    hide-footer
    body-class="p-0"
    centered
    content-class="preview-modal-content"
  >
    <button class="preview-giveaway-popup-modal__close" @click="closeModal">
      <i class="uil uil-times"></i>
    </button>
    <div class="mobile-phone-preview" v-if="popupsData">
      <!-- Mobile Phone Frame -->
      <div class="mobile-phone-frame">
        <!-- Phone Screen (dark grey background) -->
        <div class="mobile-phone-screen">
          <!-- Giveaway Popup Modal -->
          <div class="preview-giveaway-popup-modal">
            <!-- Decorative Button Image (non-functional) -->
            <div class="preview-giveaway-popup-modal__decorative-button">
              <i class="uil uil-times"></i>
            </div>
            <!-- Close Button (functional) -->
          

            <!-- Background Image Section with Graphics -->
            <div class="preview-giveaway-popup-modal__graphic-section" v-if="getImageUrl()">
              <div class="preview-giveaway-popup-modal__background">
                <img :src="getImageUrl()" :alt="getTitle() || 'Giveaway popup image'" />
              </div>
            </div>

            <!-- Content Section -->
            <div class="preview-giveaway-popup-modal__content">
              <!-- Title Text (displayed prominently) -->
              <div class="preview-giveaway-popup-modal__title" v-if="getTitle()">
                <p>{{ getTitle() }}</p>
              </div>
              <!-- Top Text Content -->
              <div class="preview-giveaway-popup-modal__text" v-if="getTopText()">
                <p>{{ getTopText() }}</p>
              </div>
              <!-- Bottom Text Content -->
              <div class="preview-giveaway-popup-modal__text" v-if="getBottomText()">
                <p>{{ getBottomText() }}</p>
              </div>

              <!-- Agreement Checkbox -->
              <div class="preview-giveaway-popup-modal__checkbox" v-if="getAgreementText()">
                <label class="preview-giveaway-popup-modal__checkbox-label">
                  <input 
                    type="checkbox" 
                    v-model="agreedToTerms"
                    class="preview-giveaway-popup-modal__checkbox-input"
                  />
                  <span class="preview-giveaway-popup-modal__checkbox-text">{{ getAgreementText() }}</span>
                </label>
              </div>

              <!-- Action Button -->
              <div class="preview-giveaway-popup-modal__actions" v-if="getActionText()">
                <button 
                  class="preview-giveaway-popup-modal__button"
                  :disabled="!agreedToTerms && getAgreementText()"
                  :style="{
                    backgroundColor: appButtonColor,
                    color: appButtonTextColor
                  }"
                >
                  {{ getActionText() }}
                </button>
              </div>

              <!-- Terms and Conditions Link -->
              <div class="preview-giveaway-popup-modal__link" v-if="getTncUrl()">
                <a 
                  :href="getTncUrl()" 
                  target="_blank" 
                  class="preview-giveaway-popup-modal__link-text"
                >
                  Algemene voorwaarden
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<style scoped>
.preview-modal-content {
  border-radius: 0;
  overflow: visible;
  background: transparent;
  border: none;
  box-shadow: none;
}

.mobile-phone-preview {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background: #f5f5f5;
}

.mobile-phone-frame {
  position: relative;
  width: 325px;
  max-width: 100%;
  background: #5C5D63;
  border-radius: 40px;
  padding: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.mobile-phone-screen {
  width: 100%;
  height: 730px;
  max-height: 80vh;
  background: #3a3a3a;
  border-radius: 32px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
}

.preview-giveaway-popup-modal {
  position: relative;
  background: #ffffff;
  border-radius: 20px;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
  max-height: 90%;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  min-height: 500px;
}

.preview-giveaway-popup-modal__decorative-button {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9;
  pointer-events: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.preview-giveaway-popup-modal__decorative-button i {
  font-size: 20px;
  color: #82B2DE;
  font-weight: 600;
  opacity: 0.5;
}

.preview-giveaway-popup-modal__close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #5C5D63;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 11;
  transition: opacity 0.2s ease;
}

.preview-giveaway-popup-modal__close:hover {
  opacity: 0.8;
}

.preview-giveaway-popup-modal__close i {
  font-size: 20px;
  color: #82B2DE;
  font-weight: 600;
}

.preview-giveaway-popup-modal__graphic-section {
  position: relative;
  width: 100%;
  max-width: 600px;
  aspect-ratio: 955 / 425;
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  overflow: hidden;
  z-index: 1;
  margin: 0 auto;
}


.preview-giveaway-popup-modal__background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  overflow: hidden;
}

.preview-giveaway-popup-modal__background img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.preview-giveaway-popup-modal__content {
  position: relative;
  z-index: 2;
  padding: 24px 20px;
  flex: 1;
  overflow-y: auto;
  background: #ffffff;
  display: flex;
  flex-direction: column;
}

.preview-giveaway-popup-modal__title {
  color: #000000;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.4;
  margin-bottom: 16px;
  text-align: center;
  text-transform: uppercase;
}

.preview-giveaway-popup-modal__title p {
  margin: 0;
}

.preview-giveaway-popup-modal__text {
  color: #000000;
  font-size: 15px;
  line-height: 1.6;
  margin-bottom: 20px;
  font-weight: 400;
  text-align: center;
   
}

.preview-giveaway-popup-modal__text p {
  margin: 0;
  text-align: center;
}

.preview-giveaway-popup-modal__checkbox {
  margin-bottom: 20px;
}

.preview-giveaway-popup-modal__checkbox-label {
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  user-select: none;
}

.preview-giveaway-popup-modal__checkbox-input {
  width: 15px;
  height: 15px;
  margin-right: 10px;
  margin-top: 2px;
  cursor: pointer;
  flex-shrink: 0;
  accent-color: #000000;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  border: 2px solid #000000;
  border-radius: 0;
  background-color: transparent;
  position: relative;
}

.preview-giveaway-popup-modal__checkbox-input:checked {
  background-color: #000000;
}

.preview-giveaway-popup-modal__checkbox-input:checked::after {
  content: '';
}

.preview-giveaway-popup-modal__checkbox-text {
  color: #000000;
  font-size: 12px;
  line-height: 1.5;
  padding-top: 2px;
  flex: 1;
}

.preview-giveaway-popup-modal__actions {
  margin-bottom: 12px;
}

.preview-giveaway-popup-modal__button {
  width: 100%;
  padding: 14px 24px;
  background: #0565BD; /* Default fallback */
  color: #ffffff; /* Default fallback */
  border: none;
  border-radius: 8px;
  font-family: 'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;
  font-size: 16px;
  font-weight: 700 !important;
  font-style: normal !important;
  text-transform: uppercase;
  cursor: pointer;
  transition: background 0.2s ease, opacity 0.2s ease;
  letter-spacing: 0.5px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

.preview-giveaway-popup-modal__button:hover:not(:disabled) {
  opacity: 0.9;
  filter: brightness(0.9);
}

.preview-giveaway-popup-modal__button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.preview-giveaway-popup-modal__link {
  text-align: center;
  margin-top: 4px;
}

.preview-giveaway-popup-modal__link-text {
  color: #82B2DE;
  text-decoration: underline !important;
  text-underline-offset: 2px;
  font-size: 14px;
  cursor: pointer;
  transition: color 0.2s ease;
  font-weight: 400;
}

.preview-giveaway-popup-modal__link-text:hover {
  color: #6a9bc5;
  text-decoration: underline !important;
}

@media (max-width: 768px) {
  .mobile-phone-frame {
    width: 100%;
    max-width: 325px;
    padding: 8px;
  }

  .mobile-phone-screen {
    height: 600px;
    padding: 15px;
  }

  .preview-giveaway-popup-modal__graphic-section {
    width: 100%;
    height: auto;
    aspect-ratio: 955 / 425;
  }

  .preview-giveaway-popup-modal__content {
    padding: 20px 16px;
  }

  .preview-giveaway-popup-modal__text {
    font-size: 14px;
  }
}

.modal-loader-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  border-radius: 8px;
}

.modal-loader-content {
  text-align: center;
  color: #5f6b7d;
  font-size: 16px;
}

.loading-blur {
  filter: blur(2px);
  opacity: 0.7;
  pointer-events: none;
}

@media (max-width: 576px) {
  .mobile-phone-preview {
    padding: 10px;
  }

  .mobile-phone-frame {
    border-radius: 30px;
    padding: 6px;
  }

  .mobile-phone-screen {
    border-radius: 24px;
    height: 500px;
    padding: 10px;
  }

  .preview-giveaway-popup-modal {
    border-radius: 16px;
    min-height: 400px;
  }

  .preview-giveaway-popup-modal__graphic-section {
    width: 100%;
    height: auto;
    aspect-ratio: 955 / 425;
  }

  .preview-giveaway-popup-modal__content {
    padding: 18px 14px;
  }

  .preview-giveaway-popup-modal__text {
    font-size: 13px;
    margin-bottom: 16px;
  }

  .preview-giveaway-popup-modal__button {
    padding: 12px 20px;
    font-size: 14px;
  }
}
</style>

